import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import MixpanelService from "../../Services/MixpanelService";

// Define the context type
interface MixpanelContextType {
  trackEvent: (_eventName: string, _properties?: Record<string, unknown>) => void;
  identifyUser: (_userId: string) => void;
  setUserProperties: (_properties: Record<string, unknown>) => void;
  reset: () => void;
  alias: (_userId: string,__currentDistinctId:string) => void;
  getDistinctId: () => string | null;
  register: (_properties: Record<string, unknown>) => void;
}

// Create Context with default value as null
const MixpanelContext = createContext<MixpanelContextType | null>(null);

// Define the provider's props type
interface MixpanelProviderProps {
  children: ReactNode;
}

export const MixpanelProvider: React.FC<MixpanelProviderProps> = ({ children }) => {
  useEffect(() => {
    MixpanelService.init();
    return () => {
      MixpanelService.reset(); // Clean up on unmount
    };
  }, []);

  return <MixpanelContext.Provider value={MixpanelService}>{children}</MixpanelContext.Provider>;
};

// Custom hook to use Mixpanel
export const useMixpanel = (): MixpanelContextType => {
  const context = useContext(MixpanelContext);
  if (!context) {
    throw new Error('useMixpanel must be used within a MixpanelProvider');
  }
  return context;
};
